import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090b] px-6" data-testid="error-boundary">
        <div className="max-w-md w-full border border-[#27272a] bg-[#18181b] p-8">
          <AlertTriangle className="w-8 h-8 text-[#c8aa6e] mb-4" strokeWidth={1.5} />
          <h1 className="font-head text-xl text-[#fafafa] mb-2">Ocorreu um erro inesperado</h1>
          <p className="text-sm text-[#a1a1aa] mb-6">
            A página encontrou um problema. Recarrega para continuar — se persistir, contacta o suporte.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="bg-[#c8aa6e] text-black hover:bg-[#d4b982] px-4 py-2.5 font-medium text-sm flex items-center gap-2"
          >
            <RefreshCw className="w-4 h-4" /> Recarregar página
          </button>
        </div>
      </div>
    );
  }
}
